import React, { useEffect, useState, useContext } from "react";
import useMediaQuery from '@mui/material/useMediaQuery';

export const PilotHouse = (props) => {

    const [sectionMarginTop, setSectionMarginTop] = useState('');
    const notMobile = useMediaQuery('(min-width:992px)');

    useEffect(() => {
        if (notMobile) {
        let rowPaddingPilothouse = document.querySelector('.box-beachclub').getBoundingClientRect().height;
        setSectionMarginTop((rowPaddingPilothouse + 100) + "px");
        }
    }, [notMobile]);

    return (
        <>
            {props.cultureCode === "en-us" &&
                <div className="container-fluid bkg-pilothouse">
                    <div className="container py-5">
                        <div className="row justify-content-center">
                            <div className="col-md-10 text-center pt-5" data-aos="zoom-in">
                                <h2 className="text-uppercase mb-3 text-white">Go further and beyond</h2>
                                <img src="images/Infynito80/pilothouse/main.jpg" alt="" className="w-100" />
                            </div>
                            <div className="col-lg-6 position-relative order-2 order-lg-1" data-aos="fade-up" data-aos-duration="1500">
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-pilothouse pin-animation" />
                                <img src="images/Infynito80/main-deck.png" alt="" className="main-deck-pilothouse w-100" />
                            </div>
                            <div className="col-lg-6 position-relative order-1 order-lg-2">
                                <div className="box box-pilothouse">
                                    <h3 className="mb-3">Raised Pilot House</h3>
                                    <p>The raised helm station provides excellent visibility and is accessed by a staircase in the center of the main deck, offering a fresh navigating experience.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row pb-lg-5" style={{ marginTop: sectionMarginTop }}></div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col text-center">
                                <h3 className="title-gallery">Gallery interiors</h3>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {props.cultureCode === "it-it" &&
                <div className="container-fluid bkg-pilothouse">
                    <div className="container py-5">
                        <div className="row justify-content-center">
                            <div className="col-md-10 text-center pt-5" data-aos="zoom-in">
                                <h2 className="text-uppercase mb-3 text-white">Oltrepassa ogni confine</h2>
                                <img src="images/Infynito80/pilothouse/main.jpg" alt="" className="w-100" />
                            </div>
                            <div className="col-lg-6 position-relative order-2 order-lg-1" data-aos="fade-up" data-aos-duration="1500">
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-pilothouse pin-animation" />
                                <img src="images/Infynito80/main-deck.png" alt="" className="main-deck-pilothouse w-100" />
                            </div>
                            <div className="col-lg-6 position-relative order-1 order-lg-2">
                                <div className="box box-pilothouse">
                                    <h3 className="mb-3">Raised Pilot House</h3>
                                    <p>La plancia di comando rialzata offre un'eccellente visibilità ed è accessibile tramite una scala al centro del ponte principale, per un'esperienza di navigazione unica.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row pb-lg-5" style={{ marginTop: sectionMarginTop }}></div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col text-center">
                                <h3 className="title-gallery">Gallery interni</h3>
                            </div>
                        </div>
                    </div>
                </div>
            }

        </>
    );




};

export default PilotHouse;